// 设备模板信息api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'DeviceTemplates/List',
        method: 'post',
        data
    })
}

export const detailApi = (data) => {
    return request({
        url: 'DeviceTemplates/byData',
        method: 'post',
        data
    })
}

export const saveApi = (data) => {
    return request({
        url: 'DeviceTemplates/save',
        method: 'post',
        data
    })
}